import { useTranslations } from 'next-intl';
import { CatButton } from 'blocks-nextjs/blocks-react/components/Button';
import { useProductDetailPageContext } from 'app/[lang]/[esite]/(core)/product/[product]/context/product-detail';
import { usePriceAndAvailabilityQuery } from 'services/priceAvailability/use-query-price-availability';
import { ProductAvailabilityByDate } from 'components/product-availability';
import { Conditional } from '@cat-ecom/pcc-components';
import { CatSkeleton } from 'components/blocks-components';
import { DealerOtherStoreAvailabilityProps } from './types';
import ErrorMessageBanner from 'components/error-inline-banner/error-inline-banner';

export const DealerOtherStoreAvailability = ({
  store,
  defaultStoreId,
  closeAvailabilityDrawer
}: DealerOtherStoreAvailabilityProps) => {
  const t = useTranslations();
  const locationCode = store?.storeLocationCode;
  const isDefaultStore = store.id.toString() === defaultStoreId;

  const { quantity, storeId, partsList, langId } =
    useProductDetailPageContext();
  const { data, isLoading, refetch, isError } = usePriceAndAvailabilityQuery({
    storeId,
    langId,
    partsList: partsList.map((item) => ({ ...item, quantity })),
    enabled: false,
    ...(!isDefaultStore && { locationCode })
  });
  const product = data?.items?.at(0);
  const sourcingDetails = product?.sourcingDetails;

  const getErrorOrSkeleton = () =>
    isError ? (
      <ErrorMessageBanner heading={t('GENERIC_ERROR_2')} />
    ) : (
      <CatSkeleton data-testid="CatSkeleton" />
    );

  return (
    <div className="mt-2">
      {!sourcingDetails?.length && !isLoading && !isError ? (
        <CatButton size="sm" onClick={() => refetch()}>
          {t('AVAILABLE_CHECK_AVAILABILITY')}
        </CatButton>
      ) : (
        <Conditional fallback={getErrorOrSkeleton()} test={!!sourcingDetails}>
          <ProductAvailabilityByDate
            sourcingDetails={sourcingDetails}
            openInDrawer={true}
            store={store}
            closeAvailabilityDrawer={closeAvailabilityDrawer}
          />
        </Conditional>
      )}
    </div>
  );
};
